export type PaginationRangeItem =
    | { type: 'page'; page: number }
    | { type: 'ellipsis'; key: string };

/**
 * Monta a lista de páginas visíveis com ellipsis.
 * Ex.: página 1 de 528 → 1, 2, 3, …, 527, 528
 * Ex.: página 51 → 1, …, 50, 51, 52, …, 528
 */
export function buildPaginationRange(
    currentPage: number,
    lastPage: number,
    siblings: number,
): PaginationRangeItem[] {
    if (lastPage <= 1) {
        return [{ type: 'page', page: 1 }];
    }

    const safeCurrent = Math.min(Math.max(currentPage, 1), lastPage);
    const pages = new Set<number>();

    pages.add(1);
    pages.add(lastPage);

    for (let page = safeCurrent - siblings; page <= safeCurrent + siblings; page += 1) {
        if (page >= 1 && page <= lastPage) {
            pages.add(page);
        }
    }

    if (safeCurrent <= siblings + 1) {
        for (let page = 1; page <= Math.min(3, lastPage); page += 1) {
            pages.add(page);
        }
    }

    if (safeCurrent <= siblings + 2 && lastPage > 3) {
        pages.add(lastPage - 1);
        pages.add(lastPage);
    }

    const sorted = [...pages].sort((a, b) => a - b);
    const items: PaginationRangeItem[] = [];

    for (let index = 0; index < sorted.length; index += 1) {
        const page = sorted[index];
        const previous = sorted[index - 1];

        if (index > 0 && page - previous > 1) {
            items.push({ type: 'ellipsis', key: `ellipsis-${previous}-${page}` });
        }

        items.push({ type: 'page', page });
    }

    return items;
}
